<div [formGroup]="form">
  <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-5">
    <div class="sml-control-group tw-col-span-2">
      <label for="locationName" class="sml-label">Location Name</label>
      <div class="tw-text-[10px] tw-leading-4 tw-text-mercury-600 tw-font-normal tw-gap-2 tw-mb-2">
      Enter a name for this location - displays with the item's details (e.g., ‘Adams Park’ or ‘Public Library’).
      </div>
      <input type="text" id="locationName" formControlName="locationName" placeholder="Enter" class="sml-control" />
    </div>
    <div class="sml-control-group tw-col-span-2" *ngIf="!(isDonated && campaignType === campaignStatus['Volunteer Activity'])">
      <span *ngIf="(campaignType===campaignStatus['Volunteer Activity'])" class="sml-label">Meet up Address</span> <span *ngIf="(campaignType!==campaignStatus['Volunteer Activity'])">Address</span>
      <div class="tw-text-[10px] tw-leading-4 tw-text-mercury-600 tw-font-normal tw-gap-2 tw-mb-2">
        <span *ngIf="(campaignType!==campaignStatus['Volunteer Activity'])"> (Optional) Provide the exact address for items that display on Map View.</span>
        </div>
      <sml-google-places-autocomplete [address]="control['address'].value" (placeSelected)="onPlaceSelected($event)"></sml-google-places-autocomplete>
      <div *ngIf="(campaignType===campaignStatus['Volunteer Activity'])" class="tw-flex tw-flex-row tw-items-center tw-gap-1 tw-text-[10px] tw-leading-4 tw-text-mercury-600 tw-font-normal tw-mb-2">
        <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon>
        <div>

          Let your volunteers know where they will need to go for this event.
        </div>

      </div> 
    </div>
    @if((campaignType!==campaignStatus['Volunteer Activity'])){

    <div class="tw-col-span-2">
      <div class="tw-w-full tw-h-5 tw-items-center tw-gap-2 tw-inline-flex">
        <div class="tw-border-t tw-border-dashed tw-border-grey-100 tw-flex-1 tw-h-[1px]">&nbsp;</div>
        <div class="tw-text-mercury-950 tw-text-sm tw-font-mediumtw-leading-tight">OR</div>
        <div class="tw-border-t tw-border-dashed tw-border-grey-100 tw-flex-1 tw-h-[1px]">&nbsp;</div>
      </div>
    </div>

    <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
      <label for="longitude" class="sml-label">Longitute</label>
      <input type="text" id="longitude" formControlName="longitude" placeholder="Enter" class="sml-control" appNumericInput 
      [ngClass]="{'sml-control-error': control['longitude'].invalid && (control['longitude'].dirty || control['longitude'].touched)}"/>
      <div class="sml-form-error" *ngIf="control['longitude'].invalid && (control['longitude'].dirty || control['longitude'].touched)">
        <p *ngIf="control['longitude'].errors?.['max'] || control['longitude'].errors?.['min']" class="tw-text-alert-800">
          Invalid longitude. Must be between -180 and 180 degrees.
        </p>
      </div>
    </div>
    <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
      <label for="latitude" class="sml-label">Latitude</label>
      <input type="text" id="latitude" formControlName="latitude" placeholder="Enter" class="sml-control" appNumericInput
      [ngClass]="{'sml-control-error': control['latitude'].invalid && (control['latitude'].dirty || control['latitude'].touched)}"/>
      <div class="sml-form-error" *ngIf="control['latitude'].invalid && (control['latitude'].dirty || control['latitude'].touched)">
        <p *ngIf="control['latitude'].errors?.['max'] || control['latitude'].errors?.['min']" class="tw-text-alert-800">
          Invalid latitude. Must be between -90 and 90 degrees.
        </p>
      </div>
    </div>
  }

  </div>
  
</div>
